export enum ScaleMethod {
  resize = 'resize',
  thumb = 'thumb',
}
